<template>
    <div class="sign-dialog" @touchmove.stop="" v-if="isShow">
        <div class="agreement-container">
            <div class="agreement-content">
                <div v-if="agreementContent" v-html="agreementContent" />
                <div v-else class="loading">
                    <van-loading color="#999" size="32px" type="spinner" />
                </div>
            </div>
            <div class="esign-container">
                <div class="esign-content" v-show="esignStatus === 1">
                    <div class="other">
                        <van-icon class="close-icon" @click="onCloseEsign" name="close" />
                        <van-button v-if="userSignImg" plain color="#07c160" @click="onNext('last')">
                            使用上次签名
                        </van-button>
                        <img v-if="userSignImg" :src="userSignImg" />
                    </div>
                    <div class="content">
                        <vue-esign
                            ref="esign"
                            :isCrop="true"
                            :quality="0.8"
                            :width="esignStyle.width"
                            :height="esignStyle.height"
                            bgColor="#ffffff"
                            :isClearBgColor="false"
                        />
                        <div class="label">签字区域</div>
                    </div>
                </div>
                <div class="btns">
                    <template v-if="esignStatus === 0">
                        <van-button @click="onClose">拒签</van-button>
                        <van-button color="#07c160" @click="esignStatus = 1">签署</van-button>
                    </template>
                    <template v-if="esignStatus === 1">
                        <van-button @click="onClearEsign">清除</van-button>
                        <van-button color="#07c160" @click="onNext('new')">确定</van-button>
                    </template>
                    <template v-if="esignStatus === 2">
                        <van-button @click="onClose">拒签</van-button>
                        <van-button color="#07c160" @click="onPay">提交并继续支付</van-button>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Button, Loading } from 'vant'
import vueEsign from 'vue-esign'
import { getLastAgreementName, previewAgreement } from '@/utils/api.js'

const _blank = '<u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp</u>'
export default {
    components: { vueEsign, VanButton: Button, VanLoading: Loading },

    data() {
        return {
            isShow: false,
            agmData: null,
            agreementContent: '',
            userSignImg: '',
            // 0未开始 1进行中 2已签名
            esignStatus: 0,

            esignStyle: { height: 240 },
        }
    },
    created() {
        function debounce(func, delay) {
            let timer
            return () => {
                clearTimeout(timer)
                timer = setTimeout(func, delay)
            }
        }
        window.addEventListener('resize', debounce(this.onResize, 100))
        this.onResize()
    },

    methods: {
        onResize() {
            const _width = document.documentElement.clientWidth
            if (_width >= 900) {
                this.esignStyle = { height: 240, width: 680 }
            } else {
                this.esignStyle = { height: 280, width: _width }
            }
        },

        onShow(data) {
            this.esignStatus = 0
            this.agmData = data
            this.isShow = true
            this.onClearEsign()
            this.previewAgreementApi()
            this.getLastAgreementNameApi()
        },
        onClose() {
            this.isShow = false
            this.$emit('onClose', false)
        },

        onClearEsign() {
            if (this.$refs.esign) {
                this.$refs.esign.reset()
            }
        },
        onCloseEsign() {
            this.esignStatus = 0
            this.onClearEsign()
        },

        onNext(type) {
            if (type === 'last') {
                this.esignImg = this.userSignImg
                this.esignStatus = 2
            } else if (type === 'new') {
                this.$refs.esign
                    .generate()
                    .then((res) => {
                        this.esignStatus = 2
                        this.esignImg = res
                    })
                    .catch(() => {
                        this.$toast('请在 签字区域 签名')
                    })
            }
        },

        onPay() {
            this.isShow = false
            this.$emit('onClose', true, this.esignImg)
        },

        previewAgreementApi() {
            let source = this.agmData.source
            previewAgreement({
                userId: this.agmData.userId,
                tplNo: this.agmData.tplNo,
                productNo: this.agmData.productNo,
                productType: this.agmData.productType,
                extra: this.agmData.extra,
                userExt: this.agmData.userExt,
                source: source,
            }).then((res) => {
                res.data.content = res.data.content.replaceAll(/{{.*?}}/g, _blank)
                this.agreementContent = res.data.content
            })
        },
        getLastAgreementNameApi() {
            getLastAgreementName({ userId: this.agmData.userId }).then((res) => {
                if (res.data && res.data.signatureBase64) {
                    this.userSignImg = res.data.signatureBase64 || ''
                }
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.sign-dialog {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
}

.agreement-container {
    width: 720px;
    background: #fff;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    .agreement-content {
        width: 100%;
        height: 480px;
        padding: 0 12px;
        box-sizing: border-box;
        overflow-y: scroll;
        .loading {
            height: 80%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        :deep(p) {
            margin: 12px 0;
            line-height: 1.5;
            font-size: 14px;
            color: #333333;
        }
    }
    .esign-container {
        border-top: 2px solid #efefef;
    }
    .esign-content {
        margin-top: 16px;
        .other {
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            margin-bottom: 8px;
            position: relative;
            padding: 0 36px;
            min-height: 40px;
            img {
                width: auto;
                height: 72px;
                margin-right: 12px;
            }
            .close-icon {
                position: absolute;
                padding: 8px;
                top: 0;
                right: 0;
                cursor: pointer;
                font-size: 18px;
            }
        }
        .content {
            position: relative;
            canvas {
                cursor: pointer;
                position: relative;
                z-index: 2;
                opacity: 0.9;
            }
            .label {
                position: absolute;
                z-index: 1;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                pointer-events: none;
                background: #bbbbbb;
                color: #000000;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
    .btns {
        margin: 16px auto 12px;
        max-width: 540px;
        display: flex;
        justify-content: space-around;
        .van-button {
            width: 140px;
            height: 36px;
        }
    }
}

@media screen and (max-width: 900px) {
    .sign-dialog {
        align-items: flex-end;
    }
    .agreement-container {
        width: 100%;
        box-sizing: border-box;
        padding: 20px 16px 0 16px;
        .agreement-content {
            width: 100%;
            height: 70vh;
            margin-bottom: 80px;
            padding-bottom: 100px;
        }
        .esign-container {
            position: absolute;
            background: #ffffff;
            bottom: 0;
            left: 0;
            width: 100%;
        }
        .esign-content {
            .other {
                img {
                    width: auto;
                    height: 72px;
                    margin-right: 12px;
                }
            }
            .content {
                position: relative;
            }
        }
        .btns {
            height: 72px;
            margin: 0 auto;
            max-width: 540px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding-bottom: 20px;
            .van-button {
                width: 130px;
                height: 32px;
                font-size: 13px;
            }
        }
    }
}
</style>
